import { f as _defineProperty, b as _objectWithoutProperties, _ as _objectSpread2 } from '../../dist/slicedToArray-1793c995.esm.js';
import _mergeDeepRight from 'ramda/src/mergeDeepRight';
import { cssVar, calc } from '@chakra-ui/react';
import { iconSizes } from '@hover/blueprint-theme';
import '@hover/utilities';
import 'ramda/src/values';
import 'ramda/src/mapObjIndexed';
import 'ramda/src/map';
import 'ramda/src/mergeDeepWith';
import { s as sizes$2, t as transition, v as variables } from '../../dist/transitions-b88a8e42.esm.js';
import '@hover/tokens-typography';
import { r as resetFocus } from '../../dist/focus-2f6da0d4.esm.js';
import { s as sizes$1, f as field, v as variants } from '../../dist/menu-5c1119be.esm.js';
import 'ramda/src/max';
import 'ramda/src/reduce';
import 'polished';
import 'ramda/src/pick';

var _excluded = ["iconBefore"];
var $fieldPaddingLeft = /*#__PURE__*/cssVar('field-padding-left');
var sizes = /*#__PURE__*/_mergeDeepRight(sizes$1, {
  "default": {
    clearButton: {
      width: 300,
      height: 300
    },
    controls: {
      width: 400,
      height: 400,
      mr: 200
    },
    field: /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty({}, $fieldPaddingLeft.variable, sizes$2[400]), "paddingRight", sizes$2[400]),
    icon: {
      width: 400,
      height: 400,
      svg: iconSizes.small
    },
    toggleButton: {
      width: 300,
      height: 300
    }
  },
  small: {
    clearButton: {
      width: 200,
      height: 200,
      svg: {
        m: 50
      }
    },
    controls: {
      width: 300,
      height: 300,
      mr: 100
    },
    field: /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty({}, $fieldPaddingLeft.variable, sizes$2[300]), "paddingRight", sizes$2[300]),
    icon: {
      width: 300,
      height: 300,
      svg: iconSizes.small
    },
    toggleButton: {
      width: 200,
      height: 200,
      svg: {
        m: 100
      }
    }
  },
  tiny: {
    clearButton: {
      width: 100,
      height: 100,
      svg: {
        m: 0
      }
    },
    controls: {
      width: 200,
      height: 200,
      mr: 100
    },
    field: /*#__PURE__*/_defineProperty( /*#__PURE__*/_defineProperty({}, $fieldPaddingLeft.variable, sizes$2[200]), "paddingRight", sizes$2[200]),
    icon: {
      width: 200,
      height: 200,
      svg: iconSizes.tiny
    },
    toggleButton: {
      width: 100,
      height: 100,
      svg: {
        m: 50
      }
    }
  }
});
var Dropdown = {
  defaultProps: {
    size: 'default'
  },
  parts: ['body', 'button', 'clearButton', 'controls', 'field', 'icon', 'item', 'list', 'loading', 'selectedItem', 'toggleButton'],
  baseStyle: function baseStyle(_ref) {
    var iconBefore = _ref.iconBefore,
      props = _objectWithoutProperties(_ref, _excluded);
    var colors = props.theme.colors;
    var baseField = field(props);
    return {
      clearButton: _objectSpread2(_objectSpread2(_objectSpread2({
        borderRadius: 300,
        border: 'none',
        background: 'transparent',
        color: 'neutral.600',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
      }, transition.easing250('background', 'color')), resetFocus(colors.softColorFor('neutral'))), {}, {
        _hover: colors.softColorFor('neutral'),
        _groupInvalid: _objectSpread2(_objectSpread2({
          color: 'danger.600'
        }, resetFocus(colors.softColorFor('danger'))), {}, {
          _hover: colors.softColorFor('danger')
        })
      }),
      toggleButton: {
        flexShrink: 0,
        color: 'neutral.700'
      },
      controls: {
        boxSizing: 'border-box',
        position: 'absolute',
        bottom: '-1px',
        right: '-1px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'end'
      },
      selectedItem: {
        cursor: 'default'
      },
      field: _objectSpread2(_objectSpread2({}, baseField), {}, {
        position: 'relative',
        display: 'inline-flex',
        direction: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1,
        paddingLeft: iconBefore ? "".concat($fieldPaddingLeft.reference, " !important") : undefined
      }),
      loading: {},
      icon: {
        boxSizing: 'border-box',
        position: 'absolute',
        bottom: '-1px',
        left: '-1px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'neutral.500',
        _groupFocus: {
          color: 'primary.900'
        },
        _groupInvalid: {
          color: 'danger.600'
        }
      },
      input: _objectSpread2({
        border: 'none',
        color: 'inherit',
        fontSize: 'inherit',
        lineHeight: 'inherit',
        width: '100%',
        _placeholder: {
          color: 'neutral.400',
          opacity: 1
        }
      }, resetFocus()),
      list: {
        padding: 0
      },
      body: {
        paddingX: 0,
        paddingY: 200,
        maxHeight: 750,
        overflowY: 'scroll'
      },
      item: _objectSpread2(_objectSpread2({}, variants["default"](props).item), {}, {
        '&[aria-selected=true]': {
          background: 'primary.100',
          color: 'primary.900'
        }
      })
    };
  },
  sizes: sizes,
  variants: {}
};

var center = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)'
};
var overlayStyles = /*#__PURE__*/_objectSpread2({
  bg: 'lightAlpha.500',
  position: 'absolute',
  right: '300',
  borderRadius: '300',
  p: '300',
  zIndex: 1
}, /*#__PURE__*/transition.easing250('opacity'));
var Gallery = {
  defaultProps: {
    size: 'default',
    variant: 'default'
  },
  parts: ['arrowTarget', 'arrowTargetNext', 'arrowTargetPrevious', 'arrowBody', 'arrowBodyNext', 'arrowBodyPrevious', 'arrowIcon', 'gridElementButton', 'gridImage', 'gridImageHoverTarget', 'gridImageHoverBody', 'gridImageHoverIcon', 'arrowFullScreenTarget', 'arrowFullScreenBody', 'arrowFullScreenIcon', 'arrowFullScreenIconAccent', 'modalBody', 'modalCloseButton', 'modalContent', 'modalHeader', 'modalHeading', 'modalImageContainer', 'modalFooter', 'modalProgress', 'modalFullScreenBody', 'modalFullScreenContent'],
  baseStyle: function baseStyle(_ref) {
    var isLoading = _ref.isLoading;
    return {
      // The interactive arrow button element
      arrowTarget: _objectSpread2({
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 0,
        position: 'absolute',
        top: 0,
        bottom: 0,
        flexBasis: '33%',
        zIndex: 3
      }, resetFocus()),
      arrowTargetNext: {
        right: 0,
        alignItems: 'flex-end'
      },
      arrowTargetPrevious: {
        left: 0,
        alignItems: 'flex-start'
      },
      // The Center component wrapping up the Icon
      arrowBody: _objectSpread2({
        background: 'neutral.0',
        paddingX: 0,
        paddingY: 300
      }, transition.easing250('transform')),
      arrowBodyNext: {
        borderTopLeftRadius: 300,
        borderBottomLeftRadius: 300,
        _groupHover: {
          transform: 'translateX(25%)'
        }
      },
      arrowBodyPrevious: {
        borderTopRightRadius: 300,
        borderBottomRightRadius: 300,
        _groupHover: {
          transform: 'translateX(-25%)'
        }
      },
      // Full Screen Arrow
      arrowFullScreenTarget: _objectSpread2(_objectSpread2({
        background: 'transparent',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        padding: 0,
        flex: 1
      }, resetFocus()), transition.easing250('transform')),
      arrowFullScreenTargetNext: {
        alignItems: 'flex-end',
        _hover: {
          transform: 'translateX(5px)'
        }
      },
      arrowFullScreenTargetPrevious: {
        alignItems: 'flex-start',
        _hover: {
          transform: 'translateX(-5px)'
        }
      },
      arrowFullScreenBody: {
        position: 'relative'
      },
      arrowFullScreenIcon: _objectSpread2(_objectSpread2({
        zIndex: 1
      }, transition.easing250('color')), {}, {
        _groupFocusVisible: {
          color: 'primary.900'
        },
        color: 'neutral.900'
      }),
      arrowFullScreenIconAccent: _objectSpread2(_objectSpread2({
        opacity: 0.2,
        strokeWidth: '4px',
        zIndex: 0,
        color: 'neutral.0',
        _groupFocusVisible: {
          color: 'primary.400',
          opacity: 0.3
        }
      }, center), transition.easing250('color', 'opacity')),
      // The arrow button Icon
      arrowIcon: {
        background: 'transparent',
        borderColor: 'transparent',
        color: 'neutral.900',
        width: 'auto',
        height: 'auto',
        _hover: {
          '&&&': {
            borderColor: 'transparent'
          }
        }
      },
      // The grid button element
      gridElementButton: _objectSpread2(_objectSpread2({
        background: 'transparent',
        border: 'none',
        borderRadius: '300',
        padding: '0',
        position: 'relative',
        cursor: 'pointer',
        overflow: 'hidden'
      }, transition.easing250('box-shadow')), resetFocus({
        shadow: 'haloPrimary'
      }, {
        shadow: 'none'
      })),
      // The image element
      gridImage: {},
      gridImageHoverTarget: {
        bottom: '0',
        left: '0',
        pointerEvents: 'none',
        position: 'absolute',
        right: '0',
        top: '0'
      },
      gridImageHoverBody: _objectSpread2({
        _groupHover: {
          opacity: isLoading ? 0 : 1,
          transform: 'scale(100%)'
        },
        bg: 'lightAlpha.400',
        borderRadius: '500',
        minWidth: '400',
        opacity: 0,
        transform: 'scale(75%)',
        width: '30%'
      }, transition.easing250('transform', 'opacity')),
      gridImageHoverIcon: {
        boxSizing: 'border-box',
        color: 'lightAlpha.800',
        p: '200'
      },
      // Modal styles
      modalBody: {
        flexDirection: 'column',
        margin: '0',
        overflow: 'hidden'
      },
      modalContent: {
        background: 'neutral.0'
      },
      modalHeading: {
        marginBottom: '100',
        textAlign: 'center',
        textStyle: 'heading500'
      },
      modalFooter: {
        marginTop: '300'
      },
      modalProgress: {
        width: '100%',
        textAlign: 'center'
      },
      modalLoading: {
        color: 'neutral.0'
      },
      modalCloseButton: {
        top: 200,
        right: 200,
        borderRadius: '100%'
      },
      // Modal Image
      modalImageContainer: {
        alignItems: 'center',
        borderRadius: '300',
        flex: 1,
        justifyContent: 'space-between',
        overflow: 'hidden',
        position: 'relative',
        '& img:first-of-type:not(img:last-of-type)': {
          // Overriding some of Framer Motion's `popLayout` styles for the
          // image being transitioned out to do our best to make the
          // transition between images of varying aspect ratios less jarring
          top: 'unset !important',
          left: 'unset !important',
          width: 'unset !important',
          objectFit: 'cover !important'
        }
      },
      modalImage: {
        borderRadius: '300',
        cursor: 'grab',
        height: 'auto',
        maxWidth: '100%'
      },
      modalImageLoading: {},
      // Full Screen Modal
      modalFullScreenBody: {
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        margin: '0',
        overflow: 'hidden',
        position: 'relative',
        display: 'flex',
        flex: 0
      },
      modalFullScreenContent: {
        paddingInline: '0',
        justifyContent: 'center'
      },
      // Helper Overlay
      helperOverlayHidden: {
        opacity: 0
      },
      helperOverlayZoomContainer: _objectSpread2(_objectSpread2({}, overlayStyles), {}, {
        top: '300'
      }),
      helperOverlayHotKeysContainer: _objectSpread2(_objectSpread2({}, overlayStyles), {}, {
        bottom: '300',
        pl: '400'
      }),
      helperOverlayHotKey: {
        alignItems: 'center',
        display: 'flex',
        height: '300',
        justifyContent: 'center',
        padding: '0',
        width: '300',
        borderRadius: '300'
      }
    };
  },
  sizes: {
    auto: {},
    "default": {},
    full: {
      arrowBody: {
        paddingX: 800
      },
      modalBody: {
        display: 'flex',
        flex: 1,
        justifyContent: 'center'
      },
      modalContent: {
        padding: 0,
        // Defining these variable to align header to the close button
        '--closeButtonPadding': {
          base: /*#__PURE__*/variables.size(200).reference,
          desktop: /*#__PURE__*/variables.size(300).reference
        },
        '--closeButtonHeight': /*#__PURE__*/variables.size(400).reference
      },
      modalCloseButton: {
        width: 'var(--closeButtonHeight)',
        height: 'var(--closeButtonHeight)',
        top: 'var(--closeButtonPadding)',
        right: {
          base: 400,
          tablet: 800
        },
        borderRadius: '100%'
      },
      arrowTarget: {
        position: 'initial',
        alignSelf: 'stretch'
      },
      arrowTargetNext: {
        right: 'auto'
      },
      arrowTargetPrevious: {
        left: 'auto'
      },
      arrowBodyNext: {
        _groupHover: {
          transform: 'translateX(8px)'
        }
      },
      arrowBodyPrevious: {
        _groupHover: {
          transform: 'translateX(-8px)'
        }
      },
      arrowIcon: {
        width: 400,
        height: 400,
        _hover: {
          '&&&': {
            borderColor: 'neutral.900'
          }
        }
      },
      modalHeader: {
        minHeight: /*#__PURE__*/calc.add('var(--closeButtonHeight)', /*#__PURE__*/calc.multiply(2, 'var(--closeButtonPadding)')),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      },
      modalHeading: {
        py: 500
      },
      modalFooter: {
        py: 500
      }
    },
    large: {},
    medium: {},
    small: {}
  },
  variants: {
    "default": {},
    dark: {
      arrowTarget: {
        flexBasis: {
          base: 200,
          tablet: '20%',
          desktop: '33%'
        }
      },
      arrowBody: {
        display: {
          base: 'none',
          tablet: 'block'
        },
        background: 'transparent'
      },
      arrowIcon: {
        color: 'neutral.0',
        _hover: {
          '&&&': {
            borderColor: 'neutral.0'
          }
        }
      },
      modalContent: {
        background: 'neutral.900'
      },
      modalProgress: {
        color: 'neutral.0'
      },
      modalHeading: {
        color: 'neutral.0'
      },
      modalCloseButton: /*#__PURE__*/_objectSpread2( /*#__PURE__*/_objectSpread2({
        border: '1px solid',
        borderColor: 'neutral.900'
      }, /*#__PURE__*/transition.easing250('border-color')), {}, {
        _focus: {
          background: 'neutral.900',
          borderColor: 'neutral.0'
        },
        _hover: {
          background: 'neutral.900',
          borderColor: 'neutral.0'
        },
        '.chakra-icon': {
          color: 'neutral.0'
        }
      })
    }
  }
};

export { Dropdown, Gallery };
